import axios from "axios";
import { bun_server } from "./baseUrl";
import { set_value_properties } from "./propertiesActions";

export const set_value_sini_data = (body) => {
  return {
    type: "set_value_sini_data",
    payload: body,
  };
};

export const sini_data_update = () => {
  return {
    type: "sini_data_update",
  };
};

/**
 * @function_name :
 * @endpoint :
 * @methode :
 * @params :
 * @body :
 * @success_response :
 * @error_response :
 */
export const gen_action = (body) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "gen_action",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };
    dispatch({
      type: "sini_data_update",
    });

    const {
      request_id,
      prompt_text,
      layer_id_list,
      layer_type_list,
      layer_name_list,
      layer_data_csv,
      project_id,
      settings,
      data_resume_fe,
    } = body;

    const chat_object_user = {
      role: "user",
      content: prompt_text,
    };
    dispatch({
      type: "push_value_sini_data",
      payload: {
        key: "chat_list",
        value: chat_object_user,
      },
    });

    const body_pre_action = {
      request_id,
      project_id,
      prompt_text,
      layer_name_list,
      layer_type_list,
      layer_id_list,
      settings,
    };

    const res_pre_action = await axios.post(
      bun_server + `/sini_v2/gen_pre_action`,
      body_pre_action,
      config
    );
    const data_pre_action = res_pre_action.data;

    console.log("data_pre_action=", data_pre_action);

    if (data_pre_action === "user_feedback") {
      const res_user_feedback = await axios.post(
        bun_server + `/sini_v2/user_feedback`,
        body_pre_action,
        config
      );
      const chat_object_ai = res_user_feedback.data;
      dispatch({
        type: "push_value_sini_data",
        payload: {
          key: "chat_list",
          value: chat_object_ai,
        },
      });
    } else if (data_pre_action === "user_ask_about_mapid") {
      const res_user_feedback = await axios.post(
        bun_server + `/sini_v2/user_ask_about_mapid`,
        body_pre_action,
        config
      );
      const chat_object_ai = res_user_feedback.data;
      dispatch({
        type: "push_value_sini_data",
        payload: {
          key: "chat_list",
          value: chat_object_ai,
        },
      });
    } else if (data_pre_action === "user_asking_help") {
      const res_user_feedback = await axios.post(
        bun_server + `/sini_v2/user_asking_help`,
        body_pre_action,
        config
      );
      const chat_object_ai = res_user_feedback.data;
      dispatch({
        type: "push_value_sini_data",
        payload: {
          key: "chat_list",
          value: chat_object_ai,
        },
      });
    } else {
      const res = await axios.post(
        bun_server + `/sini_v2/gen_action`,
        body,
        config
      );
      const layer_action_list = res?.data || [];
      let result_list = [];
      //promise start
      const delay_milliseconds = 0;
      const create_delay_promise = () =>
        new Promise((resolve) => setTimeout(resolve, delay_milliseconds));
      const process_all_items = () => {
        return layer_action_list.reduce(
          (previous_promise, current_item, index) =>
            previous_promise.then((accumulated_results) =>
              process_single_item(current_item, index).then(
                (current_result) => [...accumulated_results, current_result]
              )
            ),
          Promise.resolve([])
        );
      };
      const process_single_item = async (action_list, index) => {
        return create_delay_promise().then(() => {
          const execute_core_logic = async () => {
            try {
              const layer_id = layer_id_list?.[index];
              const layer_type = layer_type_list?.[index];
              let result_object = {};
              if (action_list?.includes("ignore")) {
                console.log("ignore");
                return;
              }
              if (action_list?.includes("gen_color")) {
                console.log("gen_color");
                const body_gen_color = {
                  prompt_text,
                  layer_id,
                  layer_type,
                  data_resume_fe,
                };
                const res = await axios.post(
                  bun_server + `/sini_v2/gen_color`,
                  body_gen_color,
                  config
                );
                const style_object = res?.data || {};
                result_object.gen_color = style_object;
                if (style_object?.action_db === "convert_text_to_number") {
                  console.log("convert_text_to_number");
                  const convert_text_to_number_object =
                    style_object?.convert_text_to_number_object;
                  dispatch({
                    type: "set_value_sini_data",
                    payload: {
                      key: "convert_text_to_number_object",
                      value: convert_text_to_number_object,
                    },
                  });
                } else if (style_object?.action_db === "push") {
                  dispatch({
                    type: "push_inside_geo_layer",
                    payload: {
                      key: "style_array",
                      value: style_object,
                      geo_layer_id: layer_id,
                    },
                  });
                  dispatch({
                    type: "set_inside_geo_layer",
                    payload: {
                      key: "default_style_key",
                      value: style_object.key,
                      geo_layer_id: layer_id,
                    },
                  });
                } else if (style_object?.action_db === "constant") {
                  dispatch({
                    type: "set_inside_array_geo_layer",
                    payload: {
                      geo_layer_id: layer_id,
                      key: "style_array",
                      key_id_child: "color_logic",
                      value_id_child: "constant",
                      value: style_object,
                    },
                  });
                  dispatch({
                    type: "set_inside_geo_layer",
                    payload: {
                      key: "default_style_key",
                      value: style_object.key,
                      geo_layer_id: layer_id,
                    },
                  });
                } else {
                  dispatch({
                    type: "set_inside_array_geo_layer",
                    payload: {
                      geo_layer_id: layer_id,
                      key: "style_array",
                      key_id_child: "field_key",
                      value_id_child: style_object?.field_key,
                      value: style_object,
                    },
                  });
                  dispatch({
                    type: "set_inside_geo_layer",
                    payload: {
                      key: "default_style_key",
                      value: style_object.key,
                      geo_layer_id: layer_id,
                    },
                  });
                }
                await dispatch(
                  set_value_properties({ key: "legend_status", value: true })
                );
              }
              if (
                action_list?.includes("gen_calc") ||
                action_list?.includes("gen_entitas")
              ) {
                console.log("gen_calc");
                const csv_data = layer_data_csv[index];
                const body_gen_calc = {
                  request_id,
                  prompt_text,
                  layer_id,
                  csv_data,
                  settings,
                };
                const res_gen_calc = await axios.post(
                  bun_server + `/sini_v2/gen_calc`,
                  body_gen_calc,
                  config
                );
                const gen_calc = res_gen_calc?.data?.gen_calc;

                result_object.gen_calc = gen_calc;
              }
              if (action_list?.includes("gen_graph")) {
                console.log("gen_graph");
                const csv_data = layer_data_csv[index];
                const body_gen_graph = {
                  request_id,
                  prompt_text,
                  layer_id,
                  csv_data,
                  settings,
                };
                const res_gen_graph = await axios.post(
                  bun_server + `/sini_v2/gen_graph`,
                  body_gen_graph,
                  config
                );

                const gen_graph = res_gen_graph?.data?.gen_graph;

                result_object.gen_graph = gen_graph;
              }
              if (action_list?.includes("gen_filter")) {
                const body_gen_color = {
                  prompt_text,
                  layer_id,
                  layer_type,
                };
                const res = await axios.post(
                  bun_server + `/sini_v2/gen_filter`,
                  body_gen_color,
                  config
                );
                console.log(res);
                await res.data.forEach((element) => {
                  const body = {
                    geo_layer_id: layer_id,
                    field_key: element.field_key,
                    value: element.value,
                  };

                  const gen_filter = res?.data;
                  result_object.gen_filter = gen_filter;

                  dispatch({
                    type: "filter_isi_layer",
                    payload: body,
                  });
                  dispatch({
                    type: "fly_action",
                  });
                });
              }
              result_list.push({
                layer_id,
                layer_name: layer_name_list[index],
                result_object,
              });
            } catch (error) {
              // error handling can be expanded here
            }
          };
          return execute_core_logic();
        });
      };
      await process_all_items().then(() => {
        try {
        } catch (error) {}
      });
      //promise end
      const body_gen_response = {
        request_id,
        prompt_text,
        layer_action_list,
        layer_id_list,
        layer_name_list,
        result_list,
        settings,
      };

      console.log(layer_name_list);
      const res_response = await axios.post(
        bun_server + `/sini_v2/gen_response`,
        body_gen_response,
        config
      );
      const chat_object_ai = res_response?.data?.chat_object || {};
      console.log(chat_object_ai);
      dispatch({
        type: "push_value_sini_data",
        payload: {
          key: "chat_list",
          value: chat_object_ai,
        },
      });
    }

    dispatch({
      type: "status_action",
    });
    dispatch({
      type: "clear_loading_action",
      payload: "gen_action",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "gen_action",
    });
  }
};

/**
 * @function_name :
 * @endpoint :
 * @methode :
 * @params :
 * @body :
 * @success_response :
 * @error_response :
 */
export const get_history_sini_data = (query) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_history_sini_data",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    const { project_id } = query;

    const res = await axios.get(
      bun_server + `/sini_v2/get_history_sini_data?project_id=${project_id}`,
      config
    );
    const data = res?.data || [];

    dispatch({
      type: "set_value_sini_data",
      payload: {
        key: "sini_data_history",
        value: data,
      },
    });

    dispatch({
      type: "clear_loading_action",
      payload: "get_history_sini_data",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_history_sini_data",
    });
  }
};

/**
 * @function_name :
 * @endpoint :
 * @methode :
 * @params :
 * @body :
 * @success_response :
 * @error_response :
 */
export const get_item_sini_data = (query) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "get_item_sini_data",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    const { request_id } = query;

    const res = await axios.get(
      bun_server + `/sini_v2/get_item_sini_data?request_id=${request_id}`,
      config
    );
    const data = res?.data || {};

    dispatch({
      type: "set_value_sini_data",
      payload: {
        key: "sini_data_selected",
        value: data,
      },
    });

    dispatch({
      type: "clear_loading_action",
      payload: "get_item_sini_data",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "get_item_sini_data",
    });
  }
};

/**
 * @function_name :
 * @endpoint :
 * @methode :
 * @params :
 * @body :
 * @success_response :
 * @error_response :
 */
export const convert_text_to_number = (body) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "convert_text_to_number",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    dispatch({
      type: "set_value_sini_data",
      payload: {
        key: "convert_progress",
        value: "pending",
      },
    });
    await axios.put(
      bun_server + `/sini_v2/convert_text_to_number`,
      body,
      config
    );
    dispatch({
      type: "set_value_sini_data",
      payload: {
        key: "convert_progress",
        value: "success",
      },
    });

    dispatch({
      type: "clear_loading_action",
      payload: "convert_text_to_number",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "convert_text_to_number",
    });
    dispatch({
      type: "set_value_sini_data",
      payload: {
        key: "convert_progress",
        value: "failed",
      },
    });
  }
};

/**
 * @function_name :
 * @endpoint :
 * @methode :
 * @params :
 * @body :
 * @success_response :
 * @error_response :
 */
export const delete_item_sini_data = (query) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "delete_value_sini_data",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    const { request_id } = query;

    await axios.get(
      bun_server + `/sini_v2/delete_item_sini_data?request_id=${request_id}`,
      config
    );

    dispatch({
      type: "delete_value_sini_data",
      payload: {
        key: "sini_data_history",
        value: query,
      },
    });

    dispatch({
      type: "clear_loading_action",
      payload: "delete_value_sini_data",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "delete_value_sini_data",
    });
  }
};
/**
 * @function_name :
 * @endpoint :
 * @methode :
 * @params :
 * @body :
 * @success_response :
 * @error_response :
 */
export const edit_title_sini_data = (query) => async (dispatch) => {
  try {
    dispatch({
      type: "set_loading_action",
      payload: "delete_value_sini_data",
    });
    dispatch({
      type: "set_loading_action",
      payload: "delete_item_sini_data",
    });
    const config = {
      headers: {
        accesstoken: localStorage.token_mapid,
      },
    };

    await axios.post(
      bun_server + `/sini_v2/edit_title_sini_data`,
      query,
      config
    );

    // dispatch({
    //   type: "delete_value_sini_data",
    //   payload: {
    //     key: "sini_data_history",
    //     value: query,
    //   },
    // });

    dispatch({
      type: "clear_loading_action",
      payload: "delete_value_sini_data",
    });
  } catch (error) {
    dispatch({
      type: "clear_loading_action",
      payload: "delete_value_sini_data",
    });
  }
};
